// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import InfoCircleTwoToneSvg from "@ant-design/icons-svg/es/asn/InfoCircleTwoTone";
import AntdIcon from '../components/AntdIcon';

var InfoCircleTwoTone = function InfoCircleTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: InfoCircleTwoToneSvg
  }));
};

InfoCircleTwoTone.displayName = 'InfoCircleTwoTone';
export default React.forwardRef(InfoCircleTwoTone);